import API_BASE_URL from "../../utils/apiBase";
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../Customer_Form/Customer_Form.css";
import { toast } from "react-toastify";
import RequiredField from "../RequiredField/RequiredField";

import SearchInputComponent from "../../utils/SearchBar.jsx";
import { useProjects } from "../../utils/projects";
import { FormSection, ProjectCards } from "../Registration/fields";


const ChannelPartnerForm = () => {
  const { projects } = useProjects();
  const location = useLocation();
  const [meetingWith, setMeetingWith] = useState("")
  const [formData, setFormData] = useState({
    companyName: "",
    meetingWith: "",
    placeOfVisit: "",
    phoneNumber: "",
    date: getCurrentDate(), // Set default value to current date
  });
  const [salesData, setSalesData] = useState('');
  useEffect(() => {
    // Fetch data from API when component mounts
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/v1/sales`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const responseData = await response.json();
      const { data, message } = responseData;
      if (!response.ok) {
        throw new Error(`${message}`);
      }
      setSalesData(data[0].names);
    } catch (error) {
      console.error("Error fetching data:", error);
      setSalesData([]);
      toast.error(`Error: ${error.message}`);
    }
  };

  // Function to get the current date in the format YYYY-MM-DD
  function getCurrentDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
   
  
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Prevent selecting future dates
    if (name === "date") {
      const selectedDate = new Date(value);
      const currentDate = new Date();

      if (selectedDate > currentDate) {
        // Reset the value to today's date
        setFormData((prevData) => ({
          ...prevData,
          date: getCurrentDate(),
        }));
        return; // Exit the function to prevent further execution
      }
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
   // Handle the selected value for meetingWith
   const handleMeetingWith = (val) => {
    const str = val;
    const parts = str.split("-"); // Split the string into parts using the dash
     const result = parts[0]; // Concatenate the first part with " XYZ-" and the second part
    setMeetingWith(result);
  };

  const userName = localStorage.getItem("username")

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      document.querySelector(".spinner").classList.add("show");
      const requestBody ={
        name: formData.name,
        companyName: formData.companyName,
        meetingWith: meetingWith,
        placeOfVisit: formData.placeOfVisit,
        phoneNumber: formData.phoneNumber,
        date: formData.date,
        createdBy: userName
      }
      const response = await fetch(
        `${API_BASE_URL}/api/v1/channel-partner/register`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );
  

      const responseData = await response.json();

      if (response.ok) {
        // Handle successful response
        // console.log("Form data sent successfully");

        toast.success(`${responseData.message}`);
        setTimeout(() => {
          navigate("/form-selection", {
            state: { AutheticatedPhoneno: formData.phoneNumber },
          });
          // console.log(formData.phoneNumber);
          document.querySelector(".spinner").classList.remove("show");
        }, 2000);
        clearForm();
      } else {
        // Handle error response
        toast.error(`${responseData.message}`);
        document.querySelector(".spinner").classList.remove("show");
      }
    } catch (error) {
      console.error("Error sending form data:", error.message);
      document.querySelector(".spinner").classList.remove("show");
    }
    // console.log("Form data:", formData);
    // Clear form fields after submission
  };

  const clearForm = () => {
    setFormData({
      companyName: "",
      meetingWith: "",
      placeOfVisit: "",
      phoneNumber: "",
    });
  };

  return (
    <div className="customerFormWrapper">
      <div className="section-head">
        <h2>Channel Partner's Detail</h2>
        <p className="section-head-sub">
          Register a channel partner · fields marked <span className="req-mark">*</span> are required
        </p>
        {userName && <span className="section-head-user">Registering as {userName}</span>}
      </div>
      <div className="form-container">
        <form onSubmit={handleSubmit}>
          <FormSection step={1} title="Partner" hint="Who is the channel partner">
            <div className="reg-field">
              <label className="reg-label" htmlFor="cp-name">
                Partner name <RequiredField />
              </label>
              <input
                id="cp-name"
                type="text"
                name="name"
                value={formData.name || ""}
                onChange={handleChange}
                placeholder="Full name"
                required
                autoComplete="off"
              />
            </div>
            <div className="reg-field">
              <label className="reg-label" htmlFor="cp-phone">
                Phone <RequiredField />
              </label>
              <input
                id="cp-phone"
                type="tel"
                inputMode="numeric"
                value={formData.phoneNumber}
                onChange={handleChange}
                autoComplete="off"
                maxLength={10}
                name="phoneNumber"
                placeholder="10-digit mobile number"
              />
            </div>
            <div className="reg-field reg-field--full">
              <label className="reg-label" htmlFor="cp-company">
                Company name <RequiredField />
              </label>
              <input
                id="cp-company"
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                placeholder="e.g. SS Landbase Realty"
                required
                autoComplete="off"
              />
            </div>
          </FormSection>

          <FormSection step={2} title="Visit details">
            <div className="reg-field">
              <label className="reg-label">Meeting with</label>
              <SearchInputComponent
                name="meetingWith"
                data={salesData}
                selectedValue={(val) => handleMeetingWith(val)}
              />
            </div>
            <div className="reg-field">
              <label className="reg-label" htmlFor="cp-date">
                Date
              </label>
              <input
                id="cp-date"
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
                autoComplete="off"
                max={getCurrentDate()} // Set the max attribute to today's date
              />
            </div>
            <div className="reg-field reg-field--full">
              <span className="reg-label">
                Place of visit <RequiredField />
              </span>
              <ProjectCards
                name="placeOfVisit"
                value={formData.placeOfVisit}
                projects={projects}
                onChange={handleChange}
                required
              />
            </div>
          </FormSection>

          <button type="submit">Register channel partner</button>
        </form>
      </div>
    </div>
  );
};

export default ChannelPartnerForm;
